<template>
  <section :class="{ 'animated-section': true, 'section-active': ready }" style="overflow: hidden">
    <div class="page-title">
      <h2>Portfolio</h2>
    </div>

    <div class="section-content">
      <div class="row">
        <div class="col-xs-12 col-sm-12">
          <!-- Portfolio Content -->
          <div class="portfolio-content">
            <ul class="portfolio-filters">
              <li :class="{ active: item.active }" v-for="(item, i) in data.categories" :key="i">
                <a class="filter btn btn-sm btn-link" :data-group="item.group">
                  {{ item.name }}
                </a>
              </li>
            </ul>

            <!-- Portfolio Grid -->
            <div class="portfolio-grid three-columns">
              <figure
                v-for="(item, i) in data.items"
                class="item standard"
                :data-groups="JSON.stringify(item.category)"
                :key="i"
              >
                <div
                  class="portfolio-item-img"
                  style="cursor: pointer"
                  @click="methods.onDetail(item)"
                >
                  <img :src="item.img" :alt="item.company" :title="item.company" />
                </div>

                <i class="far fa-file-alt"></i>
                <h4 class="name" style="font-size: 14px">{{ item.company }}</h4>
                <span class="category">{{ item.type }}</span>
              </figure>
            </div>
          </div>
          <!-- End of Portfolio Content -->
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import { onMounted, ref, onBeforeUnmount, inject } from 'vue'
import DATA from '../data'
import { useRoute, useRouter } from 'vue-router'

export default {
  setup() {
    const route = useRoute()
    const pageAjaxLoaded = inject('pageAjaxLoaded')
    if (route.query.id) {
      setTimeout(() => {
        pageAjaxLoaded.destroy = false
        pageAjaxLoaded.enabled = true
        setTimeout(() => {
          pageAjaxLoaded.ready = true
        }, 100)
      }, 2000)
    }

    const router = useRouter()
    const scrollbar = inject('scrollbar')
    const ready = ref(false)
    const data = ref(DATA.portfolio)

    function portfolio_init() {
      let portfolio_grid = $('.portfolio-grid'),
        portfolio_filter = $('.portfolio-filters')
      if (portfolio_grid) {
        portfolio_grid.shuffle({ speed: 450, itemSelector: 'figure' })
        portfolio_filter.on('click', '.filter', function (e) {
          portfolio_grid.shuffle('update')
          e.preventDefault()
          $('.portfolio-filters .filter').parent().removeClass('active')
          $(this).parent().addClass('active')
          portfolio_grid.shuffle('shuffle', $(this).attr('data-group'))
        })
      }
    }

    onMounted(() => {
      ready.value = true
      setTimeout(() => {
        scrollbar.enabled = true
        scrollbar.init = true
      }, 500)

      let $portfolio_container = $('.portfolio-grid')
      $portfolio_container.imagesLoaded(function () {
        portfolio_init(this)
      })
    })

    onBeforeUnmount(() => {
      ready.value = false
      scrollbar.enabled = false
    })

    const methods = {
      onDetail: (item) => {
        pageAjaxLoaded.destroy = false
        pageAjaxLoaded.enabled = true
        router.push({ name: 'Portfolio', query: { id: item.id } })
        setTimeout(() => {
          pageAjaxLoaded.ready = true
        }, 100)
      }
    }

    return { data, methods, ready }
  }
}
</script>
